import React from 'react';
import { Flex } from '../../Flex';
import { StyledSystemProps } from '../../../types';
import { Typography } from '../../../wag-react/components/Typography';
import { Box } from '../../../wag-react/next-components/box';
import { Icon } from '../../../wag-react/components/icon';
type Props = StyledSystemProps & {
  src: string;
  value: number;
  textProps?: StyledSystemProps;
  alt?: string;
};
export const LikeLabel = ({
  src,
  value,
  textProps,
  alt,
  ...rest
}: Props) => <Flex alignItems="center" flexDirection={['row', 'column']} backgroundColor="white" border="1px solid #EBF3EE" borderRadius="32px" px={['10px', '13px']} py={['6px', '8px']} {...rest} data-sentry-element="Flex" data-sentry-component="LikeLabel" data-sentry-source-file="LikeLabel.tsx">
    <Icon src={src} width={['16px', '24px']} height={['16px', '24px']} alt={alt} mr={['2px', '4px']} data-sentry-element="Icon" data-sentry-source-file="LikeLabel.tsx" />
    <Typography m={0} fontSize={['14px', '16px']} lineHeight="1.5" {...textProps} data-sentry-element="Typography" data-sentry-source-file="LikeLabel.tsx">
      <Box as="b" color="#4B7C68" data-sentry-element="Box" data-sentry-source-file="LikeLabel.tsx">
        {value}
      </Box>
      {' '}
      <Box as="span" opacity={0.5} fontWeight="normal" display={['none', 'inline', 'inline']} data-sentry-element="Box" data-sentry-source-file="LikeLabel.tsx">
        found this helpful
      </Box>
    </Typography>
  </Flex>;